import refreshChecker from './refresh-checker-factory/refreshCheckerFactory';
import refreshBar from './refresh-bar/refreshBar';

const module = angular.module('websked.refresh', []);

const toLoad = [
  refreshChecker,
  refreshBar
];

toLoad.forEach(fn => fn(module));
